import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// services
import { createStockActivity } from "../../../utils/services/schedulingAndStock";
import { getGroups } from "../../../utils/services/group";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";

export default function ModalNewStock(props) {
  const { isOpen, toggle, idEvent, jwt, refetch } = props;
  const [loading, setLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  // campos dinamicos
  const [separateByGroups, setSeparateByGroups] = useState("Selecione");
  const [groupAdd, setGroupAdd] = useState("");
  const [quantityAdd, setQuantityAdd] = useState(0);
  const [allGroupsAdd, setAllGroupsAdd] = useState([]);
  // lista de grupos
  const [groupsApi, setGroupsApi] = useState([]);
  // form
  const [formRoom, setFormRoom] = useState({
    room: "",
    activity: "",
    initialDate: "",
    endDate: "",
    maxQuantity: 0,
    quantityUsed: 0,
    tipo: "",
  });
  const [errors, setErrors] = useState({});

  // atualiza o campo do form e limpa o erro correspondente
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormRoom((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // valida o form e cria a atividade de estoque
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newErrors = {};

    if (!formRoom.room) newErrors.room = "O campo Sala é obrigatório";

    if (!formRoom.activity)
      newErrors.activity = "O campo Atividade é obrigatório";

    if (!formRoom.initialDate)
      newErrors.initialDate = "O campo Data e Hora Inicio é obrigatório";

    if (!formRoom.endDate)
      newErrors.endDate = "O campo Data e Hora Fim é obrigatório";

    if (formRoom.endDate < formRoom.initialDate)
      newErrors.endDate =
        "A Data e Hora Fim não pode ser menor que a Data e Hora Inicio.";

    if (formRoom.maxQuantity <= 0)
      newErrors.maxQuantity =
        "O campo Quantidade Máxima é obrigatório e deve ser maior que 0";

    if (separateByGroups === "Selecione")
      newErrors.separateByGroups =
        "O campo Segregar quantidade de vagas por grupo? é obrigatório";

    if (separateByGroups === "Sim" && allGroupsAdd.length < 1)
      newErrors.groupAdd = "Adicione pelo menos um grupo";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }

    try {
      const dataForm = {
        eventId: idEvent,
        dataHoraInicio: formRoom.initialDate,
        dataHoraFim: formRoom.endDate,
        quantidadeMax: Number(formRoom.maxQuantity),
        quantidadeUtilizada: formRoom.quantityUsed,
        atividade: formRoom.activity,
        tipo: formRoom.tipo,
        sala: formRoom.room,
        segregarPorGrupo: separateByGroups === "Sim",
        grupos: allGroupsAdd.map((e) => {
          return {
            groupId: e.group,
            quantidade: e.quantity,
          };
        }),
      };

      await createStockActivity(dataForm, jwt);

      refetch();
      setShowSuccessAlert(true);
    } catch (error) {
      console.error("Erro ao criar atividade de estoque:", error);
      setShowErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  // adiciona um grupo com a quantidade segregada, validando a quantidade disponível
  function addGroup() {
    setErrors({
      ...errors,
      groupAdd: "",
    });

    if (!groupAdd || !quantityAdd) {
      setErrors({
        ...errors,
        groupAdd: "Insira todos os dados para adicionar",
      });
      return;
    }

    var used = 0;

    allGroupsAdd.forEach((e) => {
      used = used + Number(e.quantity);
    });

    if (Number(formRoom.maxQuantity) - used < quantityAdd) {
      setErrors({
        ...errors,
        groupAdd: "Quantidade Indisponível",
      });
      return;
    }

    const dataAdd = {
      group: groupAdd,
      quantity: Number(quantityAdd),
    };

    setAllGroupsAdd([...allGroupsAdd, dataAdd]);

    setGroupAdd("");
    setQuantityAdd(0);

    setErrors({
      ...errors,
      groupAdd: "",
    });
  }

  // remove um grupo já adicionado à lista de segregação
  function removeGroup(index) {
    var groups = allGroupsAdd;

    groups = groups.filter((e, i) => i !== index);

    setAllGroupsAdd(groups);
  }

  // edita um campo (grupo ou quantidade) de um grupo já adicionado
  function editGroup(index, field, value) {
    if (field === "quantity") {
      // validar se a alteração esta dentro do valor maximo
      var used = 0;

      allGroupsAdd.forEach((e, i) => {
        if (i === index) return;

        used = used + Number(e.quantity);
      });

      if (used + Number(value) > formRoom.maxQuantity) {
        value = formRoom.maxQuantity - used;
      }
    }

    const groups = allGroupsAdd.map((group, i) =>
      i === index ? { ...group, [field]: value } : group,
    );

    setAllGroupsAdd(groups);
  }

  // ajusta a quantidade máxima sem deixá-la menor que o já segregado nos grupos
  function changeMaxQuantity(value) {
    var used = 0;

    allGroupsAdd.forEach((e) => {
      used = used + Number(e.quantity);
    });

    if (value < used) {
      value = used;
    }

    setFormRoom((prev) => ({
      ...prev,
      maxQuantity: value,
    }));
  }

  useEffect(() => {
    getGroups({
      eventId: idEvent,
      offset: 1,
      limit: 10000,
      search: "",
    })
      .then((res) => {
        if (res?.message === "Groups_by_event") {
          setGroupsApi(res.findOneGroupData.data);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar grupos:", error);
        toast.error("Erro ao buscar os grupos.");
      });
  }, [idEvent]);

  return (
    <>
      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Novo Estoque</ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Sala*</label>
                  <input
                    className="form-control"
                    type="text"
                    name="room"
                    value={formRoom.room}
                    onChange={handleChange}
                  />
                  {errors.room && (
                    <span className="text-danger">{errors.room}</span>
                  )}
                </div>
              </Col>

              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Atividade*</label>
                  <input
                    className="form-control"
                    type="text"
                    name="activity"
                    value={formRoom.activity}
                    onChange={handleChange}
                  />
                  {errors.activity && (
                    <span className="text-danger">{errors.activity}</span>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Data e Hora Inicio*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="initialDate"
                    value={formRoom.initialDate}
                    onChange={handleChange}
                  />
                  {errors.initialDate && (
                    <span className="text-danger">{errors.initialDate}</span>
                  )}
                </div>
              </Col>

              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Data e Hora Fim*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="endDate"
                    value={formRoom.endDate}
                    onChange={handleChange}
                    min={formRoom.initialDate}
                  />
                  {errors.endDate && (
                    <span className="text-danger">{errors.endDate}</span>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Tipo</label>
                  <input
                    className="form-control"
                    type="text"
                    name="tipo"
                    value={formRoom.tipo}
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col lg={6} style={{ marginBottom: 10 }}>
                <div>
                  <label className="form-label">Quantidade Máxima*</label>
                  <input
                    className="form-control"
                    type="number"
                    name="maxQuantity"
                    value={formRoom.maxQuantity}
                    onChange={(e) => {
                      changeMaxQuantity(Number(e.target.value));
                      // tranformar em number para remover o 0 inicial
                      e.target.value = Number(e.target.value);
                    }}
                  />
                  {errors.maxQuantity && (
                    <span className="text-danger">{errors.maxQuantity}</span>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <label className="form-label">
                  Segregar quantidade de vagas por grupo?
                </label>

                <select
                  className="form-control"
                  value={separateByGroups}
                  onChange={(e) => {
                    setSeparateByGroups(e.target.value);

                    setAllGroupsAdd([]);
                  }}
                >
                  <option value="Selecione">Selecione</option>
                  <option value="Não">Não</option>
                  <option value="Sim">Sim</option>
                </select>
                {errors.separateByGroups && (
                  <span className="text-danger">{errors.separateByGroups}</span>
                )}
              </Col>
            </Row>

            {separateByGroups === "Sim" && (
              <>
                <Row>
                  <Col md={9} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col lg={6}>
                        <label className="form-label">Grupo</label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            setGroupAdd(e.target.value);
                            setErrors({
                              ...errors,
                              groupAdd: null,
                            });
                          }}
                          value={groupAdd}
                        >
                          <option>Selecione</option>
                          {groupsApi &&
                            groupsApi.length > 0 &&
                            groupsApi.map((group, index) => {
                              if (
                                !allGroupsAdd.find((e) => e.group === group.id)
                              )
                                return (
                                  <option
                                    key={`optionGroup${index}`}
                                    value={group.id}
                                  >
                                    {group.name}
                                  </option>
                                );
                            })}
                        </select>
                      </Col>

                      <Col lg={6}>
                        <label className="form-label">Quantidade</label>
                        <input
                          className="form-control"
                          type="number"
                          onChange={(e) => {
                            setQuantityAdd(e.target.value);
                            setErrors({
                              ...errors,
                              groupAdd: null,
                            });
                          }}
                          value={quantityAdd}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    md={3}
                    className="mt-3"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      color="success"
                      className="btn btn-success waves-effect waves-light"
                      style={{ width: 80 }}
                      onClick={() => addGroup()}
                    >
                      Adicionar
                    </Button>
                  </Col>
                  {errors && errors.groupAdd && (
                    <span className="text-danger">{errors.groupAdd}</span>
                  )}
                </Row>

                {allGroupsAdd &&
                  allGroupsAdd.length > 0 &&
                  allGroupsAdd.map((e, i) => (
                    <div
                      style={{
                        border: "1px solid #a1e2de",
                        margin: "20px 0",
                        padding: 5,
                        borderRadius: 8,
                      }}
                      key={e.group}
                    >
                      <Row>
                        <Col md={9} style={{ marginBottom: 10 }}>
                          <Row>
                            <Col lg={6}>
                              <label className="form-label">Grupo</label>
                              <select
                                className="form-control"
                                value={e.group}
                                onChange={(value) =>
                                  editGroup(i, "group", value.target.value)
                                }
                              >
                                <option value={e.group}>
                                  {groupsApi.find(
                                    (group) => group.id === e.group,
                                  )?.name || "-"}
                                </option>
                                {groupsApi &&
                                  groupsApi.length > 0 &&
                                  groupsApi.map((group, index) => {
                                    if (
                                      !allGroupsAdd.find(
                                        (e) => e.group === group.id,
                                      )
                                    )
                                      return (
                                        <option
                                          key={`optionGroup${index}`}
                                          value={group.id}
                                        >
                                          {group.name}
                                        </option>
                                      );
                                  })}
                              </select>
                            </Col>
                            <Col lg={6}>
                              <label className="form-label">Quantidade</label>
                              <input
                                className="form-control"
                                type="number"
                                onChange={(value) => {
                                  // tranformar em number para remover o 0 inicial
                                  value.target.value = Number(
                                    value.target.value,
                                  );

                                  editGroup(
                                    i,
                                    "quantity",
                                    Number(value.target.value),
                                  );
                                }}
                                value={Number(e.quantity)}
                              />
                            </Col>
                          </Row>
                        </Col>

                        <Col
                          md={3}
                          className="mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            color="success"
                            className="btn btn-danger waves-effect waves-light"
                            style={{ width: 80 }}
                            onClick={() => removeGroup(i)}
                          >
                            Remover
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
              </>
            )}

            <Row
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                style={{ width: 80, marginRight: 10 }}
                onClick={toggle}
              >
                Fechar
              </Button>
              <ButtonSpinner
                isLoading={loading}
                title={"Salvar"}
                type="submit"
              />
            </Row>
          </form>
        </ModalBody>
      </Modal>

      {showSuccessAlert && (
        <SweetAlert
          title={`Criado`}
          success
          onConfirm={() => {
            setShowSuccessAlert(false);
            toggle();
          }}
        >
          Atividade criada com sucesso!
        </SweetAlert>
      )}

      {showErrorAlert && (
        <SweetAlert
          title="Erro"
          danger
          onConfirm={() => setShowErrorAlert(false)}
        >
          Erro ao criar a atividade de estoque.
        </SweetAlert>
      )}
    </>
  );
}
